export enum EGatewayRegistrationStatus {
    DRAFT = 'draft',
    PENDING = 'pending',
    PENDING_DOCUMENTS = 'pending_documents',
    WAITING_DOCUMENTS_APPROVAL = 'waiting_documents_approval',
    APPROVED = 'approved',
    ACTIVE = 'active',
    DENIED = 'denied',
    DISABLED = 'disabled',
    DELETED = 'deleted',
}

export enum EGatewayRegistrationType {
    BUSINESS = 'business',
    PERSONAL = 'personal',
}

export enum EGatewayRegistrationDocumentType {
    OWNER_DOCUMENT = 'owner_document',
    OWNER_ADDRESS = 'owner_address',
    ACTIVITY = 'activity',
    COMPANY_ADDRESS = 'company_address',
    COMPANY_DOCUMENT = 'company_document'
}

export enum EGatewayRegistrationCompanyType {
    MEI = 1,
    LIMITED = 2,
    INDIVIDUAL = 3,
    ASSOCIATION = 4
}

export enum EBankSlipLimitStatus {
    REQUEST = 1,
    APPROVED = 2,
    REFUSED = 3,
    INACTIVE = 4
}

export enum EGatewayAccountStatus {
    PENDING = 1,
    AWAITING_APPROVAL = 2,
    APPROVED = 3,
    REJECTED = 4
}
